import axios from 'axios';
import { UserManager } from 'oidc-client';

let userManager: UserManager | null = null;

export function initializeAxiosAuth(manager: UserManager): void {
    userManager = manager;
    // Interceptor automatically adds token to ALL axios requests
    axios.interceptors.request.use(
        async (config) => {
            if (userManager) {
                const user = await userManager.getUser();
                if (user?.access_token) {
                    config.headers.Authorization = `Bearer ${user.access_token}`;
                }
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
}

// Export for explicit checks in loaders
export async function getAccessToken(): Promise<string | null> {
    if (!userManager) { return null; }
    const user = await userManager.getUser();
    return user?.access_token ?? null;
}

export async function isAuthenticated(): Promise<boolean> {
    const token = await getAccessToken();
    return !!token;
}